module.exports = __webpack_public_path__ + "static/media/bg.00ec7932.jpg";